module.exports = ".ck.ck-link-form .ck-labeled-input{display:inline-block}.ck.ck-link-form .ck-label{display:none}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}.ck.ck-link-form>:not(:first-child){margin-left:var(--ck-spacing-standard)}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss-loader/lib??ref--1-1!./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css
// module id = 76
// module chunks = 0